import { List } from 'lucide-react'
import { Roles } from '@/utils/constants/roles'
import { env } from '@/utils/constants/env'
import { ExtendedMenuConfig } from '@/utils/configs/menu'

const availableMetabase = (env.showMetabase || 'all').split(',');

const dashboardMetabaseRoutes: ExtendedMenuConfig = {
  href: '/dashboard',
  label: 'Dashboard',
  icon: <List />,
  child: [
    { href: '/dashboard/kehadiran-makan-siang', label: 'Kehadiran & Order Makan Siang', id: 'prosesKehadiranMakanSiang' },
    { href: '/dashboard/pengajuan-cuti', label: 'Pengajuan Cuti', id: 'proses_pengajuan_cuti_ciomy' },
    { href: '/dashboard/pengajuan-reimburse', label: 'Pengajuan Reimburse', id: 'pengajuanReimburse' },
    { href: '/dashboard/pengajuan-lembur', label: 'Pengajuan Lembur', id: 'pengajuanLembur' },
    { href: '/dashboard/pengajuan-perjalanan-dinas', label: 'Pengajuan Perjalanan Dinas', id: 'pengajuanPerjalananDinas' },
    { href: '/dashboard/pengajuan-soft-loan', label: 'Pengajuan Loan', id: 'pengajuanLoan' },
    { href: '/dashboard/pengajuan-beasiswa', label: 'Pengajuan Beasiswa', id: 'pengajuanBeasiswa' },
    { href: '/dashboard/pemantauan-kpi-harian', label: 'Pemantauan KPI Harian', id: 'pemantauanKPIHarian' },
    { href: '/dashboard/kpi-bulanan', label: 'Pemantauan KPI Bulanan & Mingguan', id: 'kpiBulanan', },
    { href: '/dashboard/kpi-leadership', label: 'Pemantauan KPI Leadership', id: 'StartKPILeadership' },
    {
      href: '/dashboard/pemantauan-kpi-grd',
      label: 'Pemantauan KPI GRD',
      id: 'Pengajuan-pemantauan-KPI-GRD',
      role: [
        Roles.Director,
        Roles.ManagerHR,
        Roles.ManagerMarketingBranding,
        Roles.ManagerProduksi,
        Roles.ManagerSalesOffline,
        Roles.ManagerSalesOnline,
        Roles.ManagerWarehouse,
        Roles.StaffHR,
      ],
    }
  ].filter((route) => availableMetabase.includes(route.id) || availableMetabase.includes('all')),
}

export default dashboardMetabaseRoutes